"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowTransformerValidator = void 0;
const lodash_isfunction_1 = __importDefault(require("lodash.isfunction"));
const types_1 = require("../types");
class RowTransformerValidator {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  static createTransform(transformFunction) {
    if ((0, types_1.isSyncTransform)(transformFunction)) {
      return (row, cb) => {
        let transformed = null;
        try {
          transformed = transformFunction(row);
        } catch (e) {
          return cb(e);
        }
        return cb(null, transformed);
      };
    }
    return transformFunction;
  }
  static createValidator(validateFunction) {
    if ((0, types_1.isSyncValidate)(validateFunction)) {
      return (row, cb) => {
        cb(null, {
          row,
          isValid: validateFunction(row)
        });
      };
    }
    return (row, cb) => {
      validateFunction(row, (err, isValid, reason) => {
        if (err) {
          return cb(err);
        }
        if (isValid) {
          return cb(null, {
            row,
            isValid,
            reason
          });
        }
        return cb(null, {
          row,
          isValid: false,
          reason
        });
      });
    };
  }
  _rowTransform = null;
  _rowValidator = null;
  set rowTransform(transformFunction) {
    if (!(0, lodash_isfunction_1.default)(transformFunction)) {
      throw new TypeError('The transform should be a function');
    }
    this._rowTransform = RowTransformerValidator.createTransform(transformFunction);
  }
  set rowValidator(validateFunction) {
    if (!(0, lodash_isfunction_1.default)(validateFunction)) {
      throw new TypeError('The validate should be a function');
    }
    this._rowValidator = RowTransformerValidator.createValidator(validateFunction);
  }
  transformAndValidate(row, cb) {
    return this.callTransformer(row, (transformErr, transformedRow) => {
      if (transformErr) {
        return cb(transformErr);
      }
      if (!transformedRow) {
        return cb(null, {
          row: null,
          isValid: true
        });
      }
      return this.callValidator(transformedRow, (validateErr, validationResult) => {
        if (validateErr) {
          return cb(validateErr);
        }
        if (validationResult && !validationResult.isValid) {
          return cb(null, {
            row: transformedRow,
            isValid: false,
            reason: validationResult.reason
          });
        }
        return cb(null, {
          row: transformedRow,
          isValid: true
        });
      });
    });
  }
  callTransformer(row, cb) {
    if (!this._rowTransform) {
      return cb(null, row);
    }
    return this._rowTransform(row, cb);
  }
  callValidator(row, cb) {
    if (!this._rowValidator) {
      return cb(null, {
        row,
        isValid: true
      });
    }
    return this._rowValidator(row, cb);
  }
}
exports.RowTransformerValidator = RowTransformerValidator;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJsb2Rhc2hfaXNmdW5jdGlvbl8xIiwiX19pbXBvcnREZWZhdWx0IiwicmVxdWlyZSIsInR5cGVzXzEiLCJSb3dUcmFuc2Zvcm1lclZhbGlkYXRvciIsImNyZWF0ZVRyYW5zZm9ybSIsInRyYW5zZm9ybUZ1bmN0aW9uIiwiaXNTeW5jVHJhbnNmb3JtIiwicm93IiwiY2IiLCJ0cmFuc2Zvcm1lZCIsImUiLCJjcmVhdGVWYWxpZGF0b3IiLCJ2YWxpZGF0ZUZ1bmN0aW9uIiwiaXNTeW5jVmFsaWRhdGUiLCJpc1ZhbGlkIiwiZXJyIiwicmVhc29uIiwiX3Jvd1RyYW5zZm9ybSIsIl9yb3dWYWxpZGF0b3IiLCJyb3dUcmFuc2Zvcm0iLCJkZWZhdWx0IiwiVHlwZUVycm9yIiwicm93VmFsaWRhdG9yIiwidHJhbnNmb3JtQW5kVmFsaWRhdGUiLCJjYWxsVHJhbnNmb3JtZXIiLCJ0cmFuc2Zvcm1FcnIiLCJ0cmFuc2Zvcm1lZFJvdyIsImNhbGxWYWxpZGF0b3IiLCJ2YWxpZGF0ZUVyciIsInZhbGlkYXRpb25SZXN1bHQiLCJleHBvcnRzIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3RyYW5zZm9ybXMvUm93VHJhbnNmb3JtZXJWYWxpZGF0b3IudHMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQUEsTUFBQUEsbUJBQUEsR0FBQUMsZUFBQSxDQUFBQyxPQUFBO0FBQ0EsTUFBQUMsT0FBQSxHQUFBRCxPQUFBO0FBYUEsTUFBYUUsdUJBQXVCO0VBQ2hDO0VBQ1EsT0FBT0MsZUFBZUEsQ0FDMUJDLGlCQUE2QztJQUU3QyxJQUFJLElBQUFILE9BQUEsQ0FBQUksZUFBZSxFQUFDRCxpQkFBaUIsQ0FBQyxFQUFFO01BQ3BDLE9BQU8sQ0FBQ0UsR0FBTSxFQUFFQyxFQUEyQixLQUFVO1FBQ2pELElBQUlDLFdBQVcsR0FBYSxJQUFJO1FBQ2hDLElBQUk7VUFDQUEsV0FBVyxHQUFHSixpQkFBaUIsQ0FBQ0UsR0FBRyxDQUFDO1FBQ3hDLENBQUMsQ0FBQyxPQUFPRyxDQUFDLEVBQUU7VUFDUixPQUFPRixFQUFFLENBQUNFLENBQUMsQ0FBQztRQUNoQjtRQUNBLE9BQU9GLEVBQUUsQ0FBQyxJQUFJLEVBQUVDLFdBQVcsQ0FBQztNQUNoQyxDQUFDO0lBQ0w7SUFDQSxPQUFPSixpQkFBaUI7RUFDNUI7RUFFUSxPQUFPTSxlQUFlQSxDQUFnQkMsZ0JBQWdDO0lBQzFFLElBQUksSUFBQVYsT0FBQSxDQUFBVyxjQUFjLEVBQUNELGdCQUFnQixDQUFDLEVBQUU7TUFDbEMsT0FBTyxDQUFDTCxHQUFNLEVBQUVDLEVBQTJCLEtBQVU7UUFDakRBLEVBQUUsQ0FBQyxJQUFJLEVBQUU7VUFBRUQsR0FBRztVQUFFTyxPQUFPLEVBQUVGLGdCQUFnQixDQUFDTCxHQUFHO1FBQUMsQ0FBRSxDQUFDO01BQ3JELENBQUM7SUFDTDtJQUNBLE9BQU8sQ0FBQ0EsR0FBTSxFQUFFQyxFQUEyQixLQUFVO01BQ2pESSxnQkFBZ0IsQ0FBQ0wsR0FBRyxFQUFFLENBQUNRLEdBQUcsRUFBRUQsT0FBTyxFQUFFRSxNQUFNLEtBQVU7UUFDakQsSUFBSUQsR0FBRyxFQUFFO1VBQ0wsT0FBT1AsRUFBRSxDQUFDTyxHQUFHLENBQUM7UUFDbEI7UUFDQSxJQUFJRCxPQUFPLEVBQUU7VUFDVCxPQUFPTixFQUFFLENBQUMsSUFBSSxFQUFFO1lBQUVELEdBQUc7WUFBRU8sT0FBTztZQUFFRTtVQUFNLENBQUUsQ0FBQztRQUM3QztRQUNBLE9BQU9SLEVBQUUsQ0FBQyxJQUFJLEVBQUU7VUFBRUQsR0FBRztVQUFFTyxPQUFPLEVBQUUsS0FBSztVQUFFRTtRQUFNLENBQUUsQ0FBQztNQUNwRCxDQUFDLENBQUM7SUFDTixDQUFDO0VBQ0w7RUFFUUMsYUFBYSxHQUFtQyxJQUFJO0VBRXBEQyxhQUFhLEdBQTJCLElBQUk7RUFFcEQsSUFBV0MsWUFBWUEsQ0FBQ2QsaUJBQTZDO0lBQ2pFLElBQUksQ0FBQyxJQUFBTixtQkFBQSxDQUFBcUIsT0FBVSxFQUFDZixpQkFBaUIsQ0FBQyxFQUFFO01BQ2hDLE1BQU0sSUFBSWdCLFNBQVMsQ0FBQyxvQ0FBb0MsQ0FBQztJQUM3RDtJQUNBLElBQUksQ0FBQ0osYUFBYSxHQUFHZCx1QkFBdUIsQ0FBQ0MsZUFBZSxDQUFDQyxpQkFBaUIsQ0FBQztFQUNuRjtFQUVBLElBQVdpQixZQUFZQSxDQUFDVixnQkFBZ0M7SUFDcEQsSUFBSSxDQUFDLElBQUFiLG1CQUFBLENBQUFxQixPQUFVLEVBQUNSLGdCQUFnQixDQUFDLEVBQUU7TUFDL0IsTUFBTSxJQUFJUyxTQUFTLENBQUMsbUNBQW1DLENBQUM7SUFDNUQ7SUFDQSxJQUFJLENBQUNILGFBQWEsR0FBR2YsdUJBQXVCLENBQUNRLGVBQWUsQ0FBQ0MsZ0JBQWdCLENBQUM7RUFDbEY7RUFFT1csb0JBQW9CQSxDQUFDaEIsR0FBTSxFQUFFQyxFQUEyQjtJQUMzRCxPQUFPLElBQUksQ0FBQ2dCLGVBQWUsQ0FBQ2pCLEdBQUcsRUFBRSxDQUFDa0IsWUFBWSxFQUFFQyxjQUFjLEtBQVU7TUFDcEUsSUFBSUQsWUFBWSxFQUFFO1FBQ2QsT0FBT2pCLEVBQUUsQ0FBQ2lCLFlBQVksQ0FBQztNQUMzQjtNQUNBLElBQUksQ0FBQ0MsY0FBYyxFQUFFO1FBQ2pCLE9BQU9sQixFQUFFLENBQUMsSUFBSSxFQUFFO1VBQUVELEdBQUcsRUFBRSxJQUFJO1VBQUVPLE9BQU8sRUFBRTtRQUFJLENBQUUsQ0FBQztNQUNqRDtNQUNBLE9BQU8sSUFBSSxDQUFDYSxhQUFhLENBQUNELGNBQWMsRUFBRSxDQUFDRSxXQUFXLEVBQUVDLGdCQUFnQixLQUFVO1FBQzlFLElBQUlELFdBQVcsRUFBRTtVQUNiLE9BQU9wQixFQUFFLENBQUNvQixXQUFXLENBQUM7UUFDMUI7UUFDQSxJQUFJQyxnQkFBZ0IsSUFBSSxDQUFDQSxnQkFBZ0IsQ0FBQ2YsT0FBTyxFQUFFO1VBQy9DLE9BQU9OLEVBQUUsQ0FBQyxJQUFJLEVBQUU7WUFBRUQsR0FBRyxFQUFFbUIsY0FBYztZQUFFWixPQUFPLEVBQUUsS0FBSztZQUFFRSxNQUFNLEVBQUVhLGdCQUFnQixDQUFDYjtVQUFNLENBQUUsQ0FBQztRQUM3RjtRQUNBLE9BQU9SLEVBQUUsQ0FBQyxJQUFJLEVBQUU7VUFBRUQsR0FBRyxFQUFFbUIsY0FBYztVQUFFWixPQUFPLEVBQUU7UUFBSSxDQUFFLENBQUM7TUFDM0QsQ0FBQyxDQUFDO0lBQ04sQ0FBQyxDQUFDO0VBQ047RUFFUVUsZUFBZUEsQ0FBQ2pCLEdBQU0sRUFBRUMsRUFBMkI7SUFDdkQsSUFBSSxDQUFDLElBQUksQ0FBQ1MsYUFBYSxFQUFFO01BQ3JCLE9BQU9ULEVBQUUsQ0FBQyxJQUFJLEVBQUVELEdBQWlCLENBQUM7SUFDdEM7SUFDQSxPQUFPLElBQUksQ0FBQ1UsYUFBYSxDQUFDVixHQUFHLEVBQUVDLEVBQUUsQ0FBQztFQUN0QztFQUVRbUIsYUFBYUEsQ0FBQ3BCLEdBQU0sRUFBRUMsRUFBMkI7SUFDckQsSUFBSSxDQUFDLElBQUksQ0FBQ1UsYUFBYSxFQUFFO01BQ3JCLE9BQU9WLEVBQUUsQ0FBQyxJQUFJLEVBQUU7UUFBRUQsR0FBRztRQUFFTyxPQUFPLEVBQUU7TUFBSSxDQUFFLENBQUM7SUFDM0M7SUFDQSxPQUFPLElBQUksQ0FBQ0ksYUFBYSxDQUFDWCxHQUFHLEVBQUVDLEVBQUUsQ0FBQztFQUN0Qzs7QUF4RkpzQixPQUFBLENBQUEzQix1QkFBQSxHQUFBQSx1QkFBQSIsImlnbm9yZUxpc3QiOltdfQ==